/**
 * Shared money formatter.
 *
 * Mirrors the logic in theme.js `Currency.formatMoney` so custom scripts render
 * prices in the shop's real currency format instead of a hardcoded '$' or a
 * half-substituted placeholder. Handles every Shopify money_format placeholder —
 * a format like "€{{amount_with_comma_separator}}" printed literally before this
 * existed, because only {{amount}} was ever replaced.
 *
 * Loaded synchronously in <head> so it is available to every deferred script.
 */
window.formatShopMoney = function (cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  if (cents === null || cents === undefined || isNaN(cents)) cents = 0;

  var formatString = format ||
    (window.theme && window.theme.moneyFormat) ||
    '${{amount}}';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var match = formatString.match(placeholderRegex);
  if (!match) return formatString;

  function withDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  var value;
  switch (match[1]) {
    case 'amount_no_decimals':
      value = withDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = withDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_with_space_separator':
      value = withDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_with_apostrophe_separator':
      value = withDelimiters(cents, 2, "'", '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = withDelimiters(cents, 0, '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = withDelimiters(cents, 0, ' ');
      break;
    default: // 'amount'
      value = withDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
};
